export function FeatureHumanIllustration({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 320 180" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="320" height="180" fill="#faf9f6" />
      
      {/* UI Panel for approval */}
      <g transform="translate(60 30)">
        {/* Depth cues */}
        <rect x="-4" y="-4" width="200" height="120" rx="6" fill="none" stroke="#111111" strokeWidth="1.5" opacity="0.2" />
        <rect x="-2" y="-2" width="200" height="120" rx="6" fill="#faf9f6" stroke="#111111" strokeWidth="1.5" opacity="0.6" />
        
        <rect width="200" height="120" rx="6" fill="#ffffff" stroke="#111111" strokeWidth="1.5" />
        
        {/* Banner with warning / low confidence */}
        <g transform="translate(16 16)">
          <rect width="168" height="24" rx="4" fill="#ff5600" opacity="0.1" stroke="#ff5600" strokeWidth="1" />
          <circle cx="12" cy="12" r="4" fill="#ff5600" />
          <rect x="24" y="10" width="80" height="4" rx="2" fill="#111111" opacity="0.6" />
        </g>
        
        {/* Draft text skeleton */}
        <rect x="16" y="56" width="130" height="4" rx="2" fill="#111111" opacity="0.8" />
        <rect x="16" y="66" width="90" height="4" rx="2" fill="#111111" opacity="0.4" />
        
        {/* Approve/Reject Buttons */}
        <rect x="16" y="86" width="56" height="18" rx="4" fill="#111111" />
        <rect x="26" y="93" width="36" height="4" rx="2" fill="#ffffff" />
        
        <rect x="80" y="86" width="56" height="18" rx="4" fill="none" stroke="#111111" strokeWidth="1.5" />
        
        {/* Human Cursor coming to click Approve (Stylized) */}
        <g transform="translate(56 100)">
          <path d="M0 0 L12 12 L6 12 L4 18 L1 16 L3 10 L-5 9 Z" fill="#111111" stroke="#ffffff" strokeWidth="1.5" strokeLinejoin="round" />
        </g>
      </g>
    </svg>
  );
}
